import TypeInformationRepository from "@/repositories/dexpara/Type/TypeInformationRepository";
import makeStore from "@/storages/Base/Storage";

const store = makeStore('type', TypeInformationRepository);

export default {
    ...store,
    actions: {
        ...store.actions,
        async listAll({commit}, params) {
            commit('setLoading', true)
            await TypeInformationRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.data)
                commit('setPagination', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}